import * as React from "react"
import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { MultiTextInput } from "../inputs/multi-text-input"

interface MultiTextFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof MultiTextInput>, "value" | "onChange" | "onBlur" | "ref"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
  allowCustom?: boolean
}

export function MultiTextField<T extends FieldValues>({
  field,
  id,
  description,
  allowCustom = true,
  ...props
}: MultiTextFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <MultiTextInput id={id} error={!!error} allowCustom={allowCustom} {...field} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  tags: string[];
}

<FormField
  control={form.control}
  name="tags"
  render={({ field }) => (
    <MultiTextField<FormData>
      field={field}
      id="tags"
      label="Tags"
      placeholder="Add a tag"
      allowCustom={false} // Only allow selecting from options
      options={[
        { label: "Important", value: "important" },
        { label: "Urgent", value: "urgent" }
      ]}
    />
  )}
/>
*/
